import { default as styled } from 'styled-components';

import { spin, transitionDuration } from '@/styles/helpers';

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${spin} ${transitionDuration.verySlow} linear infinite;
`;
